import { HTMLInputTypeAttribute, useState } from "react";
import "./styles.css";
import React from "react";

export interface textboxProps {
    id: string;
    label?: string;
    value: any;
    onChange: (field: string, value: string) => any;
    setFocus?: boolean;
    maxLength: number;
    requiredIdentifier?: boolean;
    disabled?: boolean;
    validationFunc?: (val: any, maxLength: number) => {};
    errorMessage: string;
}

function TextBox(props: textboxProps) {
    const [fieldValue, setFieldValue] = useState(props.value);
    const [errorMessage, setErrorMessage] = useState("");
    React.useEffect(() => {
        setFieldValue(props.value);
        setErrorMessage(props.errorMessage);
    }, [props.value, props.errorMessage]);

    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        setFieldValue(e.currentTarget.value);
        props.onChange(props.id, e.currentTarget.value);
    };

    const validField = (e: React.FormEvent<HTMLInputElement>) => {
        if (props.validationFunc) {
            if (!props.validationFunc(e.currentTarget.value, props.maxLength)) {
                setErrorMessage("Field cannot be blank, Length must be less than  " + props.maxLength);
            }
        }
    };

    return (
        <div
            className="textBoxContainer"
            key={"Main" + props.id}
        >
            <div className="textBoxCol1">
                <label className="g-label">{props.label}</label>
                <small className="asterisk">{props.requiredIdentifier ? "*" : ""}</small>
            </div>
            <div className="textBoxCol2">
                <input
                    disabled={props.disabled}
                    className={!(errorMessage == "") ? "g-TextBox-default validationFailed " : "g-TextBox-default "}
                    onChange={handleInputChange}
                    value={fieldValue}
                    maxLength={props.maxLength}
                    autoFocus={props.setFocus}
                    autoComplete="off"
                    aria-autocomplete="none"
                    list="autocompleteOff"
                    onBlur={validField}
                    title={errorMessage}
                    type="number"
                />
            </div>
        </div>
    );
}
export default TextBox;
